import { Employee } from '../../classes/models/employee/Employee';
import { Injectable } from '@angular/core';
import { EmployeeRoleEnum } from '../../classes/enums/EmployeeRoleEnum';

/**
 * This service sorts employees by how much available they are.
 */
@Injectable({
  providedIn: 'root'
})
export class EmployeesSortService {

  /**
   * Sorts employees by their role by the original order of {@link EmployeeRoleEnum}.
   * @param employees a list of employees to be sorted.
   */
  sortByRole(employees: Employee[]): Employee[] {
    return employees.sort((first, second) => {
      const firstRoleIndex = this.findIndex(first.role);
      const secondRoleIndex = this.findIndex(second.role);
      if (firstRoleIndex === secondRoleIndex) {
        return first.employeePositionId.value > second.employeePositionId.value ? 1 : -1;
      }
      return firstRoleIndex > secondRoleIndex ? 1 : -1;
    });
  }

  private findIndex(employeeRoleEnum: EmployeeRoleEnum): number {
    return Object.values(EmployeeRoleEnum).indexOf(employeeRoleEnum);
  }
}
